module.exports = __webpack_public_path__ + "img/sign-61.356052c8.jpg";